import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d6c1c76&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1d6c1c76&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=1d6c1c76&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c1c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6c1c76')) {
      api.createRecord('1d6c1c76', component.options)
    } else {
      api.reload('1d6c1c76', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1d6c1c76&scoped=true", function () {
      api.rerender('1d6c1c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_text/index.vue"
export default component.exports